import { createContext, useContext } from 'react';
import { ApolloQueryResult } from '@apollo/client';
import { Exact, IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables } from '../../generated/hooks';

type Props = {
  children: React.ReactNode;
  user: IsAccessTokenValidQuery['isAccessTokenValid'];
  refetch: (
    variables?: Partial<Exact<IsAccessTokenValidQueryVariables>> | undefined,
  ) => Promise<ApolloQueryResult<IsAccessTokenValidQuery>>;
};

type UserContextType = {
  user: IsAccessTokenValidQuery['isAccessTokenValid'] | null;
  refetch: (
    variables?: Partial<Exact<IsAccessTokenValidQueryVariables>> | undefined,
  ) => Promise<ApolloQueryResult<IsAccessTokenValidQuery>>;
};

const UserContext = createContext<UserContextType>({
  user: null,
  refetch: undefined!,
});

export function UserProvider({ children, user, refetch }: Props) {
  const context = {
    user,
    refetch,
  };

  return <UserContext.Provider value={context}>{children}</UserContext.Provider>;
}

export const useUser = () => useContext(UserContext);
